import { jsx as C } from "react/jsx-runtime";
function t(e) {
  return /* @__PURE__ */ C("svg", { height: "50", viewBox: "0 0 50 50", width: "50", ...e, children: /* @__PURE__ */ C("g", { children: /* @__PURE__ */ C(
    "path",
    {
      clipRule: "evenodd",
      d: "M38.4712 17.526C37.4805 17.9545 36.4155 18.2443 35.2981 18.3746C36.4385 17.7074 37.3146 16.6522 37.7276 15.3942C36.6591 16.0114 35.4772 16.4601 34.2187 16.701C33.2107 15.6542 31.7747 15 30.185 15C27.1334 15 24.6596 17.412 24.6596 20.3873C24.6596 20.8096 24.7085 21.2207 24.803 21.6149C20.2106 21.3903 16.1396 19.2456 13.414 15.9861C12.9382 16.7819 12.6658 17.7074 12.6658 18.6947C12.6658 20.5636 13.6409 22.2125 15.1235 23.179C14.2181 23.1509 13.3662 22.9083 12.6214 22.5051C12.6209 22.5275 12.6209 22.55 12.6209 22.5724C12.6209 25.1827 14.5251 27.36 17.0531 27.8553C16.5894 27.9783 16.101 28.044 15.5976 28.044C15.241 28.044 14.8949 28.0103 14.5573 27.9474C15.2606 30.0876 17.3013 31.6455 19.7193 31.6887C17.8284 33.1337 15.4455 33.9951 12.857 33.9951C12.4106 33.9951 11.9711 33.9699 11.5386 33.9199C13.9836 35.4485 16.8883 36.3403 20.009 36.3403C30.1723 36.3403 35.73 28.131 35.73 21.0118C35.73 20.7782 35.7249 20.5457 35.7139 20.3149C36.7939 19.555 37.7304 18.6065 38.4712 17.526",
      fill: "currentColor",
      fillRule: "evenodd"
    }
  ) }) });
}
export {
  t as default
};
